// i18n keys of the multi-tenant work package "modpolicy" (en / zh / th). ⛔ Fill all three: an empty th value falls back to English.
export const en: Record<string, string> = {
  modacc_title: 'Module access',
  modacc_intro: 'Which modules are closed beyond the usual grants. “Admins only”: no grant opens it to anyone below admin. “Owner only”: only holders of the Owner role (below) — checked before the admin pass, so an admin who is not an owner cannot open it; an owner who is not an admin still needs the grant.',
  modacc_everyone: 'Everyone with a grant',
  modacc_everyone_shared: 'Everyone',
  modacc_admin: 'Admins only',
  modacc_owner: 'Owner only',
  modacc_shared: 'shared',
  modacc_changed: 'changed from the product default',
  modacc_using_default: 'Using the product default.',
  modacc_using_custom: 'This workspace’s own policy.',
  modacc_reset: 'Back to product default',
  modacc_reset_confirm: 'Replace this workspace’s module policy with the product default?',
  modacc_no_owner: 'No one holds the Owner role, so owner-only modules are closed to everyone, admins included. Add a member to “Owner” below.',
  modacc_owner_locked: 'Owner-only entries can be changed only by a holder of the Owner role.',
  modacc_unsaved: 'Unsaved changes',
};
export const zh: Record<string, string> = {
  modacc_title: '模块访问',
  modacc_intro: '哪些模块在常规授权之外再加限制。「仅管理员」：管理员以下的人即使勾了授权也打不开。「仅所有者」：只有下方「Owner」角色的成员可以打开——在管理员放行之前检查，所以不是所有者的管理员打不开；不是管理员的所有者仍需勾选授权。',
  modacc_everyone: '有授权的人',
  modacc_everyone_shared: '所有人',
  modacc_admin: '仅管理员',
  modacc_owner: '仅所有者',
  modacc_shared: '共享',
  modacc_changed: '已偏离产品默认',
  modacc_using_default: '当前使用产品默认设置。',
  modacc_using_custom: '当前使用本工作区自己的设置。',
  modacc_reset: '恢复产品默认',
  modacc_reset_confirm: '用产品默认设置替换本工作区的模块访问设置？',
  modacc_no_owner: '目前没有人担任「Owner」角色，所以「仅所有者」的模块对所有人关闭，包括管理员。请在下方「Owner」中添加成员。',
  modacc_owner_locked: '「仅所有者」的条目只有「Owner」角色成员才能修改。',
  modacc_unsaved: '有未保存的修改',
};
export const th: Record<string, string> = {
  modacc_title: 'สิทธิ์เข้าถึงโมดูล',
  modacc_intro: 'โมดูลใดที่ถูกจำกัดเพิ่มเติมจากการให้สิทธิ์ตามปกติ “เฉพาะผู้ดูแลระบบ”: ผู้ที่ต่ำกว่าผู้ดูแลระบบเปิดไม่ได้แม้ได้รับสิทธิ์ “เฉพาะเจ้าของ”: เฉพาะผู้ที่มีบทบาท Owner (ด้านล่าง) — ตรวจก่อนสิทธิ์ผู้ดูแลระบบ ผู้ดูแลระบบที่ไม่ใช่เจ้าของจึงเปิดไม่ได้ ส่วนเจ้าของที่ไม่ใช่ผู้ดูแลระบบยังต้องได้รับสิทธิ์โมดูลนั้น',
  modacc_everyone: 'ทุกคนที่ได้รับสิทธิ์',
  modacc_everyone_shared: 'ทุกคน',
  modacc_admin: 'เฉพาะผู้ดูแลระบบ',
  modacc_owner: 'เฉพาะเจ้าของ',
  modacc_shared: 'ใช้ร่วมกัน',
  modacc_changed: 'ต่างจากค่าเริ่มต้นของระบบ',
  modacc_using_default: 'ใช้ค่าเริ่มต้นของระบบ',
  modacc_using_custom: 'ใช้การตั้งค่าของพื้นที่ทำงานนี้',
  modacc_reset: 'กลับไปใช้ค่าเริ่มต้นของระบบ',
  modacc_reset_confirm: 'แทนที่การตั้งค่าสิทธิ์โมดูลของพื้นที่ทำงานนี้ด้วยค่าเริ่มต้นของระบบหรือไม่?',
  modacc_no_owner: 'ยังไม่มีผู้ใดมีบทบาท Owner โมดูลที่ตั้งเป็น “เฉพาะเจ้าของ” จึงปิดสำหรับทุกคน รวมถึงผู้ดูแลระบบ เพิ่มสมาชิกใน “Owner” ด้านล่าง',
  modacc_owner_locked: 'รายการ “เฉพาะเจ้าของ” แก้ไขได้เฉพาะผู้ที่มีบทบาท Owner',
  modacc_unsaved: 'มีการเปลี่ยนแปลงที่ยังไม่บันทึก',
};
